import { Icon, IconButton, IconButtonStyles, Icons, Tooltip } from '@silverfort/sf-components';
import InvestigationDrawer from '../../../components/InvestigationDrawer/InvestigationDrawer';
import { useAppDrawer } from '../../../components/AppDrawer/AppDrawerProvider';
import { FC } from 'react';

type InvestigationCellProps = {
    adType: number;
    id: string;
    isMachineAccount?: boolean;
    name: string;
    onClick?: () => void;
};

export const InvestigationCell: FC<InvestigationCellProps> = ({ adType, id, isMachineAccount, name, onClick }) => {
    const { displayContent } = useAppDrawer();

    return (
        <div className="flex">
            <span className={`flex grow ${onClick ? 'cursor-pointer' : 'cursor-default'}`} onClick={onClick}>
                {name}
            </span>

            <div className="flex gap-1 items-center invisible group-hover:visible">
                {isMachineAccount && (
                    <Tooltip childrenClassName="cursor-default" title="Machine account">
                        <Icon icon={Icons.MachineAccount} size={16} />
                    </Tooltip>
                )}

                <Tooltip childrenClassName="flex items-center" title="Investigate">
                    <IconButton
                        buttonStyle={IconButtonStyles.Secondary}
                        icon={Icons.Investigate}
                        iconSize={20}
                        onClick={() =>
                            displayContent(<InvestigationDrawer adType={adType} guid={id} identifier={name} />)
                        }
                    />
                </Tooltip>
            </div>
        </div>
    );
};
